/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../PopupTemplate.js";
import { getDisplayFieldName as t } from "../layers/support/fieldUtils.js";
import i from "../popup/content/AttachmentsContent.js";
import "../popup/content/Content.js";
import "../popup/content/CustomContent.js";
import "../popup/content/ExpressionContent.js";
import o from "../popup/content/FieldsContent.js";
import "../popup/content/MediaContent.js";
import "../popup/content/TextContent.js";
import n from "../popup/FieldInfo.js";
import r from "../popup/support/FieldInfoFormat.js";
var l = ["oid", "global-id"],
    s = ["oid", "global-id", "guid"];

function a(_ref, l) {
  var t = _ref.displayField,
      i = _ref.editFieldsInfo,
      o = _ref.fields,
      n = _ref.objectIdField,
      r = _ref.title;
  if (!o) return null;
  var s = b({
    editFieldsInfo: i,
    fields: o,
    objectIdField: n
  }, l);
  if (!s.length) return null;
  var a = j({
    titleBase: r,
    fields: o,
    displayField: t
  }),
      d = C();
  return new e({
    title: a,
    content: d,
    fieldInfos: s
  });
}

var d = [/^fnode_$/i, /^tnode_$/i, /^lpoly_$/i, /^rpoly_$/i, /^poly_$/i, /^subclass$/i, /^subclass_$/i, /^rings_ok$/i, /^rings_nok$/i, /shape/i, /perimeter/i, /objectid/i, /_i$/i],
    p = function p(e, _ref2) {
  var t = _ref2.editFieldsInfo,
      i = _ref2.objectIdField,
      o = _ref2.visibleFieldNames;
  return o ? o.has(e.name) : !m(e.name, t) && (!i || e.name !== i) && !(l.indexOf(e.type) > -1) && !d.some(function (t) {
    return t.test(e.name);
  });
};

function u(e, t) {
  var i = e;
  return t && (e = e.filter(function (e) {
    return -1 === t.indexOf(e.type);
  })), e === i && (e = e.slice()), e.sort(c), e;
}

function c(e, t) {
  return "oid" === e.type ? -1 : "oid" === t.type ? 1 : y(e) ? -1 : y(t) ? 1 : (e.alias || e.name).toLocaleLowerCase().localeCompare((t.alias || t.name).toLocaleLowerCase());
}

function m(e, t) {
  if (!e || !t) return !1;
  var i = t.creationDateField,
      o = t.creatorField,
      n = t.editDateField,
      r = t.editorField;
  return -1 !== [i && i.toLowerCase(), o && o.toLowerCase(), n && n.toLowerCase(), r && r.toLowerCase()].indexOf(e.toLowerCase());
}

function f(e, t) {
  return e.editable && -1 === s.indexOf(e.type) && !m(e.name, t);
}

function F(e, t) {
  return new o({
    fieldInfos: b(e, t).filter(function (e) {
      return e.visible;
    })
  });
}

function b(_ref3, o) {
  var e = _ref3.editFieldsInfo,
      t = _ref3.fields,
      i = _ref3.objectIdField;
  return u(t, (null == o ? void 0 : o.ignoreFieldTypes) || g).map(function (t) {
    return new n({
      fieldName: t.name,
      isEditable: f(t, e),
      label: t.alias,
      format: w(t),
      visible: p(t, {
        editFieldsInfo: e,
        objectIdField: i,
        visibleFieldNames: null == o ? void 0 : o.visibleFieldNames
      })
    });
  });
}

function w(e) {
  switch (e.type) {
    case "small-integer":
    case "integer":
    case "single":
      return new r({
        digitSeparator: !0,
        places: 0
      });

    case "double":
      return new r({
        digitSeparator: !0,
        places: 2
      });

    case "date":
      return new r({
        dateFormat: "long-month-day-year"
      });

    default:
      return null;
  }
}

function C() {
  return [new o(), new i()];
}

function j(e) {
  var i = t(e),
      o = e.titleBase;
  return i ? "".concat(o, ": {").concat(i.trim(), "}") : o;
}

function y(e) {
  if ("name" === (e.name && e.name.toLowerCase())) return !0;
  return "name" === (e.alias && e.alias.toLowerCase()) || void 0;
}

var g = ["geometry", "blob", "raster", "guid", "xml"];
export { b as createFieldInfos, F as createFieldsContent, a as createPopupTemplate };